<ng-container *ngIf="isLoading$ | async">
  <div class="dds-modal-overlay dds-d-grid dds-align-content-center dds-justify-content-center">
    <dds-spinner
      size="48px"
      theme="green"
      thickness="4px">
    </dds-spinner>
  </div>
</ng-container>
